import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activityTypes: [],
  isAllSelected: true,
  isLoading: true,
};

//toggleActivityTypeSelection is for changing the isSelected key from the activity types. only the subtypes & trending themes of the selected activity types will be displayed in the below sliders
const activityTypes = createSlice({
  name: "activityTypes",
  initialState,
  reducers: {
    updateActivityTypes: (state, { payload }) => {
      state.activityTypes = payload;
    },
    toggleAllSelected: (state, { payload }) => {
      state.isAllSelected = payload;
    },
    toggleActivityTypeSelection: (state, { payload }) => {
      return {
        ...state,
        activityTypes: state.activityTypes.map((activityType) => (activityType.id === payload.id ? { ...activityType, isSelected: !activityType.isSelected } : activityType)),
      };
    },
    selectAllActivityTypes: (state, { payload }) => {
      return {
        ...state,
        activityTypes: state.activityTypes.map((activityType) => ({ ...activityType, isSelected: true })),
      };
    },
    selectSingleActivityType: (state, { payload }) => {
      return {
        ...state,
        activityTypes: state.activityTypes.map(activityType => (activityType.id === payload.id ? { ...activityType, isSelected: true } : { ...activityType, isSelected: false })),
      };
    },
    deselectAllActivityTypes: (state, { payload }) => {
      return {
        ...state,
        activityTypes: state.activityTypes.map((activityType) => ({ ...activityType, isSelected: false })),
      };
    },
    setSubtypes: (state, { payload }) => {
      return {
        ...state,
        activityTypes: state.activityTypes.map((activityType) => {
          return activityType.id === payload.activityTypeId ? { ...activityType, subtypes: [...activityType.subtypes, payload.subtype] } : activityType
        })
      };
    },
    setSubtypesMasters: (state, { payload }) => {
      return {
        ...state,
        activityTypes: state.activityTypes.map(activityType => {
          return activityType.id === payload.activityTypeId ? {
            ...activityType,
            subtypes: activityType.subtypes.map(subtype => {
              return subtype.id === payload.subtypeId ? { ...subtype, masters_data: payload.data } : subtype
            })
          } : activityType
        })
      };
    },
    toggleIsLoading: (state, { payload }) => {
      state.isLoading = payload
    },
  },
});

export const { updateActivityTypes, toggleActivityTypeSelection,
  selectAllActivityTypes, deselectAllActivityTypes,
  setSubtypes, setSubtypesMasters,
  toggleAllSelected, toggleIsLoading, selectSingleActivityType
} = activityTypes.actions;
export default activityTypes.reducer;
